import { ROUTE_STORAGE } from '@aide/constants'
import cloneDeep from 'lodash/cloneDeep'
import isEmpty from 'lodash/isEmpty'

import { ref } from 'vue'

const ROUTE_PROPERTY = {
  ENABLED: 'enabled',
  FINISHED: 'finished'
}

// GLOBAL DATA
const storageRoutes = ref({})

export default function useStorageRoute() {

  // METHODS
  function clearStorageRoutes() {
    localStorage.removeItem(ROUTE_STORAGE)
    storageRoutes.value = {}
  }

  function initStorageRoutes() {
    const existingRoutes = JSON.parse(localStorage.getItem(ROUTE_STORAGE))
    if (!existingRoutes) {
      updateStorageRoutes({
        needs: {},
        products: {},
      })
    } else {
      storageRoutes.value = existingRoutes
    }
  }

  function updateStorageRoutes(routes) {
    localStorage.setItem(ROUTE_STORAGE, JSON.stringify(routes))
    storageRoutes.value = routes
  }

  function updateStorageNeedEnabled(personId, isEnabled = true) {
    return updateStorageNeed(personId, ROUTE_PROPERTY.ENABLED, isEnabled)
  }

  function updateStorageNeedFinished(personId, isFinished = true) {
    return updateStorageNeed(personId, ROUTE_PROPERTY.FINISHED, isFinished)
  }

  function updateStorageNeed(personId, property, propertyValue) {
    const currentStorageRoutes = cloneDeep(storageRoutes.value)
    if (!currentStorageRoutes.needs[personId]) {
      currentStorageRoutes.needs[personId] = {}
    }

    const currentStorageNeed = currentStorageRoutes.needs[personId]
    Object.assign(currentStorageNeed, { [property]: propertyValue })
    updateStorageRoutes(currentStorageRoutes)
  }

  function updateStorageProductFinished(categoryId, personId) {
  return updateStorageProduct(categoryId, personId, ROUTE_PROPERTY.FINISHED)
  }

  function updateStorageProductEnabled(categoryId, personId) {
    return updateStorageProduct(categoryId, personId, ROUTE_PROPERTY.ENABLED)
  }

  function updateStorageProduct(categoryId, personId, property) {
    const currentStorageRoutes = cloneDeep(storageRoutes.value)
    if (!currentStorageRoutes.products[categoryId]) {
      currentStorageRoutes.products[categoryId] = {}
    }

    if (!currentStorageRoutes.products[categoryId][personId]) {
      currentStorageRoutes.products[categoryId][personId] = {}
    }

    const currentStorageProduct = currentStorageRoutes.products[categoryId][personId]
    Object.assign(currentStorageProduct, { [property]: true })
    updateStorageRoutes(currentStorageRoutes)
  }

  function resetStorageProduct(personId, categories) {
    const currentStorageRoutes = cloneDeep(storageRoutes.value)
    const resetCategories = categories ?? Object.keys(currentStorageRoutes.products)
    resetCategories.forEach(categoryId => {
      delete currentStorageRoutes.products[categoryId][personId]
      if (isEmpty(currentStorageRoutes.products[categoryId])) {
        delete currentStorageRoutes.products[categoryId]
      }
    })
    updateStorageRoutes(currentStorageRoutes)
  }

  return {
    storageRoutes,
    clearStorageRoutes,
    initStorageRoutes,
    resetStorageProduct,
    updateStorageNeedEnabled,
    updateStorageNeedFinished,
    updateStorageProductEnabled,
    updateStorageProductFinished,
  }

}
